import React, { useEffect, useState } from 'react';
import { Box, Flex, Text, VStack } from '@chakra-ui/react';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import styled from '@emotion/styled';
import { ObjectBase, ObjectText } from '../../types/ObjectTypes';
import { getTextByMarkType } from '../../services/Object/ObjectTextsDataService';

export const LeafletContainer = styled.div`
  width: 100%;

  .leaflet-container {
    height: 500px;
    width: 500px;
  }

  @media (max-width: 767px) {
    .leaflet-container {
      width: 100%;
    }
  }
`;

export interface ObjectLocationProps {
  baseData: ObjectBase;
  textsData: Array<ObjectText>;
}

export const ObjectLocation = (props: ObjectLocationProps): JSX.Element => {
  const { baseData, textsData } = props;
  const [locationDescription, setLocationDescription] = useState<string>('');

  useEffect(() => {
    setLocationDescription(getTextByMarkType(textsData, 'M7'));
  }, [textsData]);

  return (
    <>
      <link
        rel="stylesheet"
        href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css"
        integrity="sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A=="
        crossOrigin=""
      />
      <Box
        p={4}
        borderRadius={{ sm: 0, md: 4, lg: 4, xl: 4 }}
        borderWidth={1}
        borderColor={'gray.300'}
        backgroundColor={'white'}
        w={'100%'}
        h={{ base: '100%', md: 'unset' }}
        overflow={'auto'}>
        <VStack gridGap={4} alignItems={'flex-start'}>
          <Text w={'100%'} textAlign={'left'} fontSize={'xl'} textStyle={'category.primary'}>
            Lage
          </Text>
          <Flex
            flexDirection={{ base: 'column', md: 'row' }}
            alignItems={'flex-start'}
            w={{ base: '100%', md: 'unset' }}>
            <LeafletContainer>
              <MapContainer
                center={[
                  Number.parseFloat(baseData.Position.split(',')[0]),
                  Number.parseFloat(baseData.Position.split(',')[1]),
                ]}
                zoom={13}
                scrollWheelZoom={false}
                id={'mapbox/satellite-v9'}>
                <TileLayer
                  id={'mapbox/satellite-v9'}
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={[51.505, -0.09]}>
                  <Popup>
                    A pretty CSS3 popup. <br /> Easily customizable.
                  </Popup>
                </Marker>
              </MapContainer>
            </LeafletContainer>
            <Text
              ml={{ base: 0, md: '10px' }}
              mt={{ base: '10px', md: 0 }}
              dangerouslySetInnerHTML={{
                __html: locationDescription,
              }}
            />
          </Flex>
        </VStack>
      </Box>
    </>
  );
};
